import GppMaybeIcon from '@mui/icons-material/GppMaybe';

function UnauthorizedPage() {
  return (
    <div style={{ textAlign: "center", margin: 50 }}>
      <GppMaybeIcon color='warning' sx={{ transform: "scale(5)", m: 5 }} /><br />
      <h2>403 - Forbidden</h2>
      Sorry, you are not authorized to access this page
    </div>
  );
}

export default UnauthorizedPage;